
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { APP_UI } from "../ui/appUi";
import AppNotificationsButton from "./AppNotificationsButton";

export default function WorkflowPageHeader({
  step,
  title,
  onBack,
  actions,
  showBack = true,
  totalSteps = 4,
}: {
  step: number;
  title: string;
  onBack: () => void;
  actions?: ReactNode;
  showBack?: boolean;
  totalSteps?: number;
}) {
  return (
    <Stack direction="row" spacing={0.8} sx={{ alignItems: "center", mb: 0.75 }}>
      {showBack && (
        <IconButton onClick={onBack} aria-label="Zurück" sx={{ color: "#fff", width: APP_UI.touch, height: APP_UI.touch }}>
          <ArrowBackRoundedIcon />
        </IconButton>
      )}
      <Box sx={{ width: 36, height: 36, flex: "0 0 auto", borderRadius: 2.2, display: "grid", placeItems: "center", bgcolor: APP_UI.accentSoft, border: `1px solid rgba(131,206,224,.28)` }}>
        <Typography variant="caption" sx={{ color: APP_UI.accent, fontWeight: 950 }}>{step}/{totalSteps}</Typography>
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="caption" sx={{ color: APP_UI.accent, fontWeight: 900, letterSpacing: ".06em" }}>SCHRITT {step} VON {totalSteps}</Typography>
        <Typography variant="h5" noWrap sx={{ fontWeight: 900, color: "#fff", lineHeight: 1.05, letterSpacing: "-.018em" }}>{title}</Typography>
      </Box>
      <AppNotificationsButton />
      {actions}
    </Stack>
  );
}
